import { render, staticRenderFns } from "./answer-lawyer-card.vue?vue&type=template&id=3f04c4c6&scoped=true&"
import script from "./answer-lawyer-card.vue?vue&type=script&lang=js&"
export * from "./answer-lawyer-card.vue?vue&type=script&lang=js&"
import style0 from "./answer-lawyer-card.vue?vue&type=style&index=0&id=3f04c4c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f04c4c6",
  null
  
)

export default component.exports